import { FC, useCallback } from 'react';
import { Appointment } from '@weave/schema-gen-ts/dist/schemas/appointments/v3/model.pb';
import { AppointmentsApiQueries } from '@frontend/api-appointments';
import { AppointmentSelectorComponents } from '@frontend/appointment-selector';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader, Text, BannerNotification } from '@frontend/design-system';
import { useSendFormsStore } from '../../../providers';
import {
  appointmentsContainerStyle,
  textStyle,
  bannerNotificationStyle,
  stepStyle,
} from './appointment-selection.styles';
import AttachDocuments from './attach-documents/attach-documents.component';

const EMPTY_APPOINTMENTS: Appointment[] = [];

const Appointments: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { personId, locationId, setAppointmentId, setAppointmentInfo } = useSendFormsStore([
    'personId',
    'locationId',
    'setAppointmentInfo',
    'setAppointmentId',
  ]);
  const appointmentsQuery = AppointmentsApiQueries.useListPersonAppointments({
    locationId,
    personId,
  });
  const appointments = appointmentsQuery.data?.appointments ?? EMPTY_APPOINTMENTS;

  const selectAppointmentHandler = useCallback(
    (appointment: Appointment) => {
      setAppointmentInfo({
        appointmentAt: appointment.appointmentAt,
        pmsType: appointment.pmsType,
        practitioner: appointment.practitioner,
      });
      setAppointmentId(appointment?.appointmentId);
    },
    [setAppointmentInfo, setAppointmentId]
  );

  return (
    <>
      {appointments.length > 0 ? (
        <div css={appointmentsContainerStyle}>
          <Text color='light' css={textStyle}>
            {t("Link a form to recipient's upcoming appointment")}
          </Text>
          <AppointmentSelectorComponents.AppointmentsList
            appointments={appointments}
            onSelect={selectAppointmentHandler}
          />
        </div>
      ) : (
        <BannerNotification status='info' css={bannerNotificationStyle}>
          {t('No Upcoming Appointments')}
        </BannerNotification>
      )}
      <ContentLoader show={appointmentsQuery.isLoading} message={t('Loading appointments...')} />
    </>
  );
};

const AppointmentSelectionStep: FC = () => {
  return (
    <div css={stepStyle}>
      <Appointments />
      <AttachDocuments />
    </div>
  );
};

export default AppointmentSelectionStep;
